/**
 * @generated SignedSource<<64b04f5949db9dfd8c9e5e1a1506f2c4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RewardKind = "BADGE" | "LEARNING" | "MONEY" | "SWAG";
import { FragmentRefs } from "relay-runtime";
export type RewardFragment$data = {
  readonly amount: {
    readonly end: number;
    readonly start: number;
  } | null | undefined;
  readonly id: string;
  readonly kind: RewardKind;
  readonly " $fragmentType": "RewardFragment";
};
export type RewardFragment$key = {
  readonly " $data"?: RewardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RewardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RewardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AmountRange",
      "kind": "LinkedField",
      "name": "amount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Reward",
  "abstractKey": null
};

(node as any).hash = "4660d89d77e1eb93388a06616f6b80cd";

export default node;
